export default "__VITE_ASSET__B_MSowbi__"